import { Injectable } from '@angular/core';
import * as contracts from './contracts/user';
import * as models from '../../models';
import { gql, Apollo } from 'apollo-angular';
import { GetCurrentUserQuery } from '../../../shared/graphql-types';
import { CookieService } from 'ngx-cookie';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { UserMapper } from './mappers/user-mapper';
import { AuthService } from '@auth0/auth0-angular';


@Injectable()
export class UserService implements contracts.IUserService {
  constructor(
    private apollo: Apollo,
    private cookieService: CookieService,
    private auth: AuthService,
  ) { }

  getUser(request: contracts.GetUserRequest): Observable<contracts.GetUserResponse> {
    return this.apollo.query<GetCurrentUserQuery>({
      query: gql(`
      query getCurrentUser {
        getCurrentUser {
          firstName,
          lastName,
          accounts {
            eulaAccepted
            operator {
              operatorUuid
              operatorAgreement
              legalName
              name
              eulaAccepted
              prospectus {
                approved
              }
            }
            superUser
          }
          userId
          emailAddress
          permissions
        }
      }`),
      fetchPolicy: 'network-only'
    })
      .pipe(
        map(svcResp => {
          const response = new contracts.GetUserResponse();
          if (!svcResp.data) {
            return response;
          }
          response.entity = UserMapper.Instance().userDtoToUser(svcResp.data.getCurrentUser);
          return response;
        })
      );
  }

  signOut(request: contracts.SignOutRequest): Observable<contracts.SignOutResponse> {
    const host = location.host.split('.');
    if (host.length > 2) {
      let i = 2;
      while (i < host.length) {
        const subdomain = '.' + location.host.split('.').splice(-i, i).join('.');
        i++;
        this.cookieService.removeAll({ domain: subdomain });
      }
    }
    this.cookieService.removeAll();

    localStorage.removeItem('selectedAngelOperatorUuid')
    this.auth.logout({ logoutParams: { returnTo: window.location.origin } });
    return of(new contracts.SignOutResponse());
  }

  logUserActivity(request: models.UserActionsEnum): Observable<contracts.LogUserActivityResponse> {
    return this.apollo.mutate<GetCurrentUserQuery>({
      mutation: gql(`mutation logUserActivity($action: UserActivityAction!) {
        logUserActivity(action: $action) {
          action
        }
      }`),
      variables: {
        action: request
      }
    }).pipe(
      map((svcResp) => {
        return new contracts.LogUserActivityResponse();
      })
    );
  }
}
